module.exports = __webpack_public_path__ + "img/oin-pay-icon.6653bdc0.svg";